export default __webpack_public_path__ + "static/media/Eina02-RegularItalic.ef56578d.ttf";